import '@shoelace-style/shoelace/dist/themes/light.css';
import '@shoelace-style/shoelace/dist/components/drawer/drawer';
import '@shoelace-style/shoelace/dist/components/details/details';

class NavigationPanel {
  constructor() {
    this.showButtonEl = document.querySelector('[data-aside-toggle]');
    this.hideButtonEl = document.querySelector('[data-aside-close]');
    this.asideEl = document.querySelector('[data-aside]');

    this.showAside = this.showAside.bind(this);
    this.hideAside = this.hideAside.bind(this);

    this.addEventListeners();
  }

  addEventListeners() {
    this.showButtonEl.addEventListener('click', this.showAside);
    this.hideButtonEl.addEventListener('click', this.hideAside);
  }

  showAside() {
    this.asideEl.show();
  }

  hideAside() {
    this.asideEl.hide();
  }
}
export default new NavigationPanel();
